module.exports = "/images/Courbe fond.png?bff03557ba809f7d8e30453d472fbc5e";